import React, { useState } from 'react';
//import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import PropTypes from 'prop-types';

// MUI stuff
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import Badge from '@material-ui/core/Badge';

// Icons
import NotificationsIcon from '@material-ui/icons/Notifications';
import FavoriteIcon from '@material-ui/icons/Favorite';
import ChatIcon from '@material-ui/icons/Chat';

// Redux
import { connect } from 'react-redux';
import { markNotificationsRead, markOneNotificationRead } from '../redux/actions/userActions';


const Notifications = (props) => {

  const { notifications } = props;
  const [anchorEl, setAnchorEl] = useState(null);

  dayjs.extend(relativeTime);

  const handleOpen = (event) => {
    setAnchorEl(event.target);
  };

  const handleClose = (index) => {
    setAnchorEl(null);
    if(typeof notifications[index] !== 'undefined'){
      console.log(notifications[index].notificationId);
      props.markOneNotificationRead(notifications[index].notificationId);
    }
  };

  const markAllRead = () => {
    let unreadNotificationsIds = notifications
      .filter((not) => !not.read)
      .map((not) => not.notificationId);
    props.markNotificationsRead(unreadNotificationsIds);
    setAnchorEl(null);
  };

  let notificationsIcon;
  if (notifications && notifications.length > 0) {
    notifications.filter((not) => not.read === false).length > 0
      ? (notificationsIcon = (
        <Badge
          badgeContent={
            notifications.filter((not) => not.read === false).length
          }
          color="secondary"
        >
          <NotificationsIcon />
        </Badge>
      ))
      : (notificationsIcon = <NotificationsIcon />);
  } else {
    notificationsIcon = <NotificationsIcon />;
  }

  let notificationsMarkup =
    notifications && notifications.length > 0 ? (
      notifications.map((not, index) => {
        const verb = not.type === 'like' ? 'liked' : 'commented on';
        const time = dayjs(not.createdAt).fromNow();
        const iconColor = not.read ? 'primary' : 'secondary';
        const icon =
          not.type === 'like' ? (
            <FavoriteIcon color={iconColor} style={{ marginRight: 10 }} />
          ) : (
            <ChatIcon color={iconColor} style={{ marginRight: 10 }} />
          );
          return (
            <MenuItem 
              key={not.createdAt}
              onClick={() => handleClose(index)}
            >
              {icon}
              <Typography
                color="primary"
                variant="body1"
                //component={Link}
                //to={`/users/${not.recipient}/scream/${not.screamId}`}
              >
                {not.sender} {verb} your scream {time}
              </Typography>
            </MenuItem>
          );
      })
    ) : (
      <MenuItem onClick={handleClose}>
        You have no notifications yet
      </MenuItem>
    );

  return (
    <div>
      <Tooltip placement="top" title="Notifications">
        <IconButton
          aria-owns={anchorEl ? 'simple-menu' : undefined}
          aria-haspopup="true"
          onClick={handleOpen}
        >
          {notificationsIcon}
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        //onEntered={onMenuOpened}
      >
        {notificationsMarkup}
        <MenuItem onClick={markAllRead} style={{textAlign: 'center'}}>
          Mark All Read
        </MenuItem>
      </Menu>
    </div>
  );

};

Notifications.propTypes = {
  markNotificationsRead: PropTypes.func.isRequired,
  markOneNotificationRead: PropTypes.func.isRequired,
  notifications: PropTypes.array.isRequired
};

const mapStateToProps = (state) => ({
  notifications: state.user.notifications
});

const mapDispatchToProps = {
  markNotificationsRead,
  markOneNotificationRead
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Notifications);